import * as React from 'react';

import { Shimmer } from '../../../../../common/Shimmer';
import { AnimationElement } from '../../../../../common/Animation';

import { layoutAnimationConfig } from './constants';
import * as styles from './BetPositionLayout.css';

interface IBetPositionLayoutProps {
  loading: boolean;
  betPosition: React.ReactNode;
}

export const BetPositionLayout = ({ loading, betPosition }: IBetPositionLayoutProps) => {
  return (
    // Китовый тултип не подошел, поскольку есть проблемы позиционирования при переключении карточек и при движении слайдера
    <div className={styles['tooltip']}>
      <AnimationElement {...layoutAnimationConfig}>
        <Shimmer theme="black" running={loading}>
          <div className={styles['content']}>{betPosition}</div>
        </Shimmer>
      </AnimationElement>
    </div>
  );
};
